export default "__VITE_ASSET__BMpCKPek__"